import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_CHAT_CARDS(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.MESSAGES, name: name, contents: [] };
  let sep = "\n ㅤㅤ";

  cat.contents = [
    BH.label("Bild & Website"),
    BH.withNested(
      BH.card("CARD_IMG_FROM_BLOCK_NEW", "Bild:" + sep, "{{src[@check=IMAGE,URL]}}\n", "await RAGAI.CARDS.image({ src: {{src}} });"),
      [{ forValue: 'src', isShadow: false, targetBlockType: 'BLOCK_STACK_IMAGE' }]
    ),
    BH.withNested(
      BH.card("CARD_IFRAME", "iFrame (Website)" + sep, "{{url[@check=URL]}}\nCSS-Class:{{?css}}", "await RAGAI.CARDS.iframe({{url}},{{css}});"),
      [
        { forValue: "url", isShadow: false, targetBlockType: BLOCKLY_DUMMY.URL },
        { forValue: 'css', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "my-theme" } }
      ]
    ),

    BH.label("Media"),
    BH.withNested(
      BH.card("CARD_HTML", BLOCKLY_CARD_PREFIX.HTML + sep, "{{html}}\nCSS-Class:{{?css}}", "await RAGAI.CARDS.html({{html}},{{css}});"),
      [
        { forValue: 'html', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "<b>Hello world</b>" } },
        { forValue: 'css', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "my-theme" } }
      ]),

    BH.withNested(
      BH.card("CARD_YOUTUBE", BLOCKLY_CARD_PREFIX.YOUTUBE + sep, "{{videoId}}\nCSS-Class:{{?css}}", "await RAGAI.CARDS.youtube({{videoId}},{{css}});"),
      [
        { forValue: 'videoId', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "videoId" } },
        { forValue: 'css', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "my-theme" } }
      ]),
    BH.withNested(
      BH.card("CARD_VIMENO", BLOCKLY_CARD_PREFIX.VIMEO + sep, " {{videoId}}\nHASH:{{?hash}}\nCSS-Class:{{?css}}", "await RAGAI.CARDS.vimeo({{videoId}},{{hash}},{{css}});"),
      [
        { forValue: 'videoId', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "videoId" } },
        { forValue: 'hash', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "" } },
        { forValue: 'css', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "my-theme" } }
      ])
  ];

  return cat;
}
